import { Flex, IconButton, Input, Radio, Checkbox } from '@chakra-ui/react'

import { Trash } from 'components/icons'
import { CustomFormQuestionOptionsProps } from '../..'

type Props = CustomFormQuestionOptionsProps & {
  index: number
  option: string
}

function CustomFormQuestionOption({ options, option, index, type, formMethods }: Props) {
  function handleUpdate(index: number, newValue: string) {
    const optionsArray = options
    optionsArray[index] = newValue
    formMethods.setValue('options', optionsArray)
  }

  async function removeOption(currentOption: string) {
    if (options) {
      const optionsArray = options.filter((option) => {
        return option !== currentOption
      })
      formMethods.setValue('options', optionsArray)
    }
  }

  return (
    <Flex alignItems="center" gap={2} w="full">
      {type === 'RADIO' && <Radio size="md" colorScheme="primary" defaultChecked={true} isDisabled={true} />}
      {type === 'SELECT' && <Checkbox size="md" colorScheme="primary" defaultChecked={true} isDisabled={true} />}
      {type === 'CHECKBOX' && <Checkbox size="md" colorScheme="primary" defaultChecked={true} isDisabled={true} />}
      {option === 'Outro' ? (
        <Input
          rounded="none"
          disabled
          bg="transparent"
          border="none"
          borderBottom="1px"
          _placeholder={{ color: 'dark', opacity: 1 }}
          placeholder="Outro:"
        />
      ) : (
        <Input
          w="full"
          placeholder="Digite a opção"
          defaultValue={option}
          onBlur={(event) => handleUpdate(index, event.target.value)}
        />
      )}

      <IconButton
        icon={<Trash />}
        aria-label="icon"
        variant="ghost"
        size="sm"
        colorScheme="red"
        onClick={() => removeOption(option)}
      />
    </Flex>
  )
}

export default CustomFormQuestionOption
